const indexItems = [
  { label: '热血格斗', icon: 'ri-sword-line', count: '1,286部', color: 'text-primary-500', bg: 'bg-primary-50' },
  { label: '恋爱校园', icon: 'ri-heart-line', count: '1,052部', color: 'text-accent-500', bg: 'bg-accent-50' },
  { label: '悬疑推理', icon: 'ri-search-eye-line', count: '864部', color: 'text-secondary-500', bg: 'bg-secondary-50' },
  { label: '异世界', icon: 'ri-earth-line', count: '1,423部', color: 'text-primary-500', bg: 'bg-primary-50' },
  { label: '搞笑日常', icon: 'ri-emotion-laugh-line', count: '978部', color: 'text-accent-500', bg: 'bg-accent-50' },
  { label: '少女言情', icon: 'ri-star-line', count: '1,135部', color: 'text-secondary-500', bg: 'bg-secondary-50' },
  { label: '科幻未来', icon: 'ri-rocket-line', count: '743部', color: 'text-primary-500', bg: 'bg-primary-50' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-18 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            分类索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500 text-center">
            按题材快速浏览，找到你喜欢的漫画类型
          </p>
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7 gap-3">
            {indexItems.map((item) => (
              <a
                key={item.label}
                href="#index"
                onClick={(e) => e.preventDefault()}
                className={`group flex flex-col items-center gap-2 p-4 rounded-xl ${item.bg} border border-transparent hover:border-background-300 transition-all duration-200 cursor-pointer`}
              >
                <div className={`w-10 h-10 flex items-center justify-center rounded-lg ${item.bg} ${item.color}`}>
                  <i className={`${item.icon} text-lg`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                  {item.label}
                </span>
                <span className="text-xs text-foreground-400">
                  {item.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}